module.exports = __webpack_public_path__ + "static/media/p7.d82e2e17.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/p7.png
// module id = 1302
// module chunks = 0